module.exports = __webpack_public_path__ + "static/media/addCertificate.2139e0e2.png";